import api from '../api';
import WizzeeLog from './wizzeeLog';

const generateSIMReference = async eSimSelected => {
  try {
    let simType;
    if (eSimSelected) {
      simType = 'eSIM';
    } else {
      simType = 'STANDARD_SIM';
    }
    const simResourceSpecification =
      await api.fetchResourceSpecification('SIM');
    const sims = await api.fetchResourceWithResourceSpecificationOuidAndType(
      simResourceSpecification.ouid,
      simType,
    );
    if (!sims.length) {
      return 'None available';
    }

    WizzeeLog.log(
      '>>> generateSIMReference() - ' + simType + ' générée: ',
      sims[0].resourceSerialNumber,
    );

    return sims[0].resourceSerialNumber;
  } catch (e) {
    let random = 1110 + Math.floor(Math.random() * (2109 - 1110));
    const simReference = '89601917019726' + random;
    return simReference.toString();
  }
};

export default generateSIMReference;
